import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaves = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 28C10.0599 28 11.106 27.7588 12.0589 27.2946C13.0118 26.8305 13.8466 26.1556 14.5 25.321C15.1534 26.1556 15.9882 26.8306 16.9411 27.2947C17.894 27.7589 18.94 28.0001 20 28.0001C21.06 28.0001 22.106 27.7589 23.0589 27.2947C24.0118 26.8306 24.8466 26.1556 25.5 25.321C26.1534 26.1556 26.9882 26.8305 27.9411 27.2946C28.894 27.7588 29.9401 28 31 28",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 21C10.0599 21 11.106 20.7588 12.0589 20.2946C13.0118 19.8305 13.8466 19.1556 14.5 18.321C15.1534 19.1556 15.9882 19.8306 16.9411 20.2947C17.894 20.7589 18.94 21.0001 20 21.0001C21.06 21.0001 22.106 20.7589 23.0589 20.2947C24.0118 19.8306 24.8466 19.1556 25.5 18.321C26.1534 19.1556 26.9882 19.8305 27.9411 20.2946C28.894 20.7588 29.9401 21 31 21",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 14C10.0599 14 11.106 13.7588 12.0589 13.2946C13.0118 12.8305 13.8466 12.1556 14.5 11.321C15.0655 12.0433 15.7677 12.6471 16.5665 13.098C17.3653 13.5489 18.2451 13.838 19.1557 13.9489C20.0663 14.0598 20.9898 13.9902 21.8735 13.7442C22.7572 13.4982 23.5837 13.0805 24.306 12.515C24.751 12.167 25.152 11.766 25.5 11.321C26.1534 12.1556 26.9882 12.8305 27.9411 13.2946C28.894 13.7588 29.9401 14 31 14",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgWaves);
export default ForwardRef;
